import { Input, useDebounceCallback } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export function CreditInvoicesNameFilter() {
  const nav = useNavigate({ from: "/app/billing/credit-invoices" });
  const search = useSearch({ from: "/app/billing/credit-invoices" });
  const nameFromUrl =
    typeof search.name === "string" ? search.name : "";

  const [value, setValue] = useState(nameFromUrl);

  useEffect(() => {
    setValue(nameFromUrl);
  }, [nameFromUrl]);

  const debounced = useDebounceCallback((val: string) => {
    const trimmed = val.trim();
    nav({
      search: {
        ...search,
        offset: 0,
        name: trimmed || undefined,
      },
    });
  }, 400);

  return (
    <Input
      id="credit-name-search"
      defaultValue={value}
      placeholder="ຄົ້ນຫາຊື່..."
      className="h-9 w-full sm:max-w-xs"
      onChange={(e) => {
        debounced(e.target.value);
      }}
    />
  );
}
